import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import classes from './scss/appliedJobs.module.scss';
import PaginationPanel from '../../common/PaginationPanel/PaginationPanel';
import RecommendedJobsList from '../../common/ListsOfComponents/RecommendedJobsList';
import JobCardSkeleton from '../../common/Skeletons/JobCardSkeleton';
import AppliedJobsList from '../../common/ListsOfComponents/AppliedJobsList';

function AppliedJobs(props) {
  const { jobsData, counter, recommendedJobs, currentPage, setCurrentPage } = props;

  const completedProfile = localStorage.getItem('userProfileCompleted') === 'true';

  const pendingFetch = useSelector((state) => state.jobs.pendingFlag);

  const pagination = useSelector((state) => state.jobs.pagination);

  const { t } = useTranslation();

  return (
    <>
      <div className="row pt-5">
        <div className={`d-flex align-items-center flex-wrap ${classes.titleContainer}`}>
          <h1 className="d-inline align-middle text-nowrap">{t('dashboard.jobs.appliedjobs')}</h1>
          {Array.isArray(jobsData) && (
            <span className="align-middle text-nowrap">
              <Trans i18nKey="dashboard.jobs.foundjobs" counter={counter}>
                Found {{ counter }} job{counter > 1 ? 's' : ''}
              </Trans>
            </span>
          )}
        </div>
      </div>
      <div className="row pt-4 w-100">
        <div className="col-md-12 pt-4 mb-5" style={{ gap: '19px' }}>
          <AppliedJobsList jobsData={jobsData} pendingFetch={pendingFetch} />
          <div className={classes.pagination}>
            {Array.isArray(jobsData) && (
              <PaginationPanel total={pagination?.TotalPages} active={currentPage} setActive={setCurrentPage} />
            )}
          </div>
          {!!recommendedJobs.length && completedProfile && (
            <div className={`row pt-5 ${classes.recommended}`}>
              <div className="col-12">
                <h5>{t('dashboard.jobs.recommended')}</h5>
                {pendingFetch ? (
                  <div className={classes.skeletonContainer}>
                    {Array.from({ length: 3 }, (v, k) => k).map((_, idx) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <JobCardSkeleton key={idx} />
                    ))}
                  </div>
                ) : (
                  <RecommendedJobsList jobsData={recommendedJobs} />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AppliedJobs;
